import { Button, Group, Textarea } from "@mantine/core";
import { Check } from "lucide-react";

import { STYLE_MIN_CHARS, STYLE_PLACEHOLDER } from "./advanced";

/**
 * Live's Style editor (`advanced-form/text-form`, capture 25): it takes the place of the
 * Advanced composer's body, its text a draft until Save. Live types its placeholder out letter by
 * letter; ours shows it whole.
 */
export function StyleText({ text, onChange }: { text: string; onChange: (text: string) => void }) {
  return (
    <Textarea
      variant="unstyled"
      aria-label="Style"
      placeholder={STYLE_PLACEHOLDER}
      autosize
      minRows={2}
      maxRows={6}
      value={text}
      onChange={(event) => onChange(event.currentTarget.value)}
    />
  );
}

export interface StyleActionsProps {
  text: string;
  onCancel: () => void;
  onSave: () => void;
}

/** Live's Cancel, which keeps the Style as it was, and Save, grey under ten characters. */
export function StyleActions({ text, onCancel, onSave }: StyleActionsProps) {
  return (
    <Group justify="flex-end" gap={12} wrap="nowrap">
      <Button variant="subtle" color="gray" onClick={onCancel}>
        Cancel
      </Button>
      <Button
        leftSection={<Check size={20} strokeWidth={1.5} />}
        disabled={text.length < STYLE_MIN_CHARS}
        onClick={onSave}
      >
        Save
      </Button>
    </Group>
  );
}
